<!-- AlloyLoggingSection.vue -->
<template>
  <div class="space-y-6 glass-panel dark:text-bg-gray">
    <div class="flex items-center gap-2 mb-4">
      <h2 class="font-semibold text-gray-800 dark:text-gray-200 capitalize">Logging</h2>
      <div class="relative group">
        <button type="button" class="bg-transparent hover:bg-transparent" @click="$emit('start-tutorial')" aria-label="Section tutorial">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="dark:text-gray-50 text-gray-900"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>
        </button>
        <span class="absolute top-full text-xs left-0 glass-card mb-1 px-1.5 py-0.5 text-white bg-gray-800 dark:bg-gray-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">Tutorial</span>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="flex flex-col">
        <label for="log_level" class="mb-1 font-medium text-gray-700 dark:text-gray-50">Log Level</label>
        <GlassSelect
          id="log_level"
          v-model="modelValue.log_level"
          :options="logLevelOptions"
          valueKey="value"
          labelKey="label"
          placeholder="Select log level"
        />
      </div>
      <div class="flex flex-col">
        <label for="log_format" class="mb-1 font-medium text-gray-700 dark:text-gray-50">Log Format</label>
        <GlassSelect
          id="log_format"
          v-model="modelValue.log_format"
          :options="logFormatOptions"
          valueKey="value"
          labelKey="label"
          placeholder="Select log format"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import GlassSelect from '@/components/GlassSelect.vue'

defineProps({
  modelValue: {
    type: Object,
    required: true
  }
})

defineEmits(['update:modelValue', 'start-tutorial'])

const logLevelOptions = [
  { value: 'debug', label: 'Debug' },
  { value: 'info', label: 'Info' },
  { value: 'warn', label: 'Warn' },
  { value: 'error', label: 'Error' },
]

const logFormatOptions = [
  { value: 'logfmt', label: 'logfmt' },
  { value: 'json', label: 'JSON' },
]
</script>
